export enum VatReturnFilingDefaultTaskGroups {
  VAT_RETURNS = 'VAT_RETURNS',
}

export enum VatReturnFilingDefaultTasks {
  START_PREPARATION = 'START_PREPARATION',
  UPDATE_DATA = 'UPDATE_DATA',
  APPROVE_DATA = 'APPROVE_DATA',
  MARK_FILING_COMPLETE = 'MARK_FILING_COMPLETE',
  UPLOAD_ACKNOWLEDGEMENT = 'UPLOAD_ACKNOWLEDGEMENT',
}
